import React from 'react';
import { resultItem } from '../../../proptypes/Actions';
import ResultValueBlock from '../ResultValueBlock/ResultValueBlock';

const ResultValueOnly = (props) => {
  return (
    <ResultValueBlock
      title={props.resultItem.title}
      value={props.resultItem.value}
    />
  );
};

ResultValueOnly.propTypes = {
  resultItem: resultItem,
};

export default ResultValueOnly;
